document.addEventListener("DOMContentLoaded", () => {

    /* =========================================================
       SWIPER — NO TOCAR
    ========================================================= */

    document.querySelectorAll(".brms-slider").forEach(slider => {

        const totalSlides =
            slider.querySelectorAll(".swiper-slide").length;

        const swiper = new Swiper(slider, {
            slidesPerView: 1,
            speed: 650,
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            grabCursor: true,
            loop: totalSlides > 1
        });

        slider.brmsSwiper = swiper;

        const nextButtons = slider.querySelectorAll(".brms-next");

        nextButtons.forEach(button => {

            button.addEventListener("click", function(e) {

                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                swiper.slideNext();

            }, true);

        });

        const prevButtons = slider.querySelectorAll(".brms-prev");

        prevButtons.forEach(button => {

            button.addEventListener("click", function(e) {

                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                swiper.slidePrev();

            }, true);

        });

    });


    /* =========================================================
       MODULAR SELECTION
    ========================================================= */

    document.querySelectorAll(".br-modular-showcase").forEach(section => {

        const selection =
            section.querySelector("[data-brms-selection]");

        if (!selection) return;


        const empty =
            selection.querySelector("[data-brms-selection-empty]");

        const productsContainer =
            selection.querySelector("[data-brms-selection-products]");

        const addAll =
            selection.querySelector("[data-brms-selection-add-all]");


        let selectedProducts = [];


        /* =====================================================
           RENDER PILL
        ===================================================== */

        const renderSelection = () => {

            if (!selectedProducts.length) {

                empty.style.display = "flex";
                productsContainer.style.display = "none";
                productsContainer.innerHTML = "";

                addAll.hidden = true;

                return;
            }


            empty.style.display = "none";

            productsContainer.style.display = "flex";

            addAll.hidden = false;


            productsContainer.innerHTML =
                selectedProducts.map(product => {

                    return `
                        <div
                            class="brms-selection-card"
                            data-selected-variant="${product.variantId}">

                            <img
                                class="brms-selection-card-image"
                                src="${product.image}"
                                alt="${product.title}"
                                loading="lazy">

                            <div class="brms-selection-card-info">

                                <div class="brms-selection-card-title">
                                    ${product.title}
                                </div>

                                ${
                                    product.comparePrice
                                    ? `
                                        <div class="brms-selection-card-price">
                                            ${product.price}
                                        </div>
                                    `
                                    : `
                                        <div class="brms-selection-card-price">
                                            ${product.price}
                                        </div>
                                    `
                                }

                            </div>

                            <button
                                type="button"
                                class="brms-selection-remove"
                                data-remove-product="${product.variantId}"
                                aria-label="Eliminar">

                                ×

                            </button>

                        </div>
                    `;

                }).join("");

        };


        /* =====================================================
           AGREGAR PRODUCTO A LA PILL
           NO AGREGA AL CARRITO
        ===================================================== */

        section.addEventListener("click", e => {

            const btn =
                e.target.closest(".brms-add");

            if (!btn || !section.contains(btn)) return;

            e.preventDefault();
            e.stopPropagation();

            if (btn.disabled) return;


            const product = {

                productId:
                    btn.dataset.productId,

                variantId:
                    btn.dataset.variant,

                title:
                    btn.dataset.title || "",

                image:
                    btn.dataset.image || "",

                price:
                    btn.dataset.price || "",

                comparePrice:
                    btn.dataset.comparePrice || ""

            };


            /* Evitar duplicados */

            const alreadySelected =
                selectedProducts.some(
                    item => item.variantId === product.variantId
                );


            if (!alreadySelected) {

                selectedProducts.push(product);

                renderSelection();

            }


            /* Cambiar estado visual del botón */

            btn.classList.add("is-added");

            btn.textContent = "Agregado ✓";

        });


        /* =====================================================
           ELIMINAR PRODUCTO DE LA PILL
        ===================================================== */

        selection.addEventListener("click", e => {

            const remove =
                e.target.closest("[data-remove-product]");

            if (!remove) return;


            e.preventDefault();
            e.stopPropagation();


            const variantId =
                remove.dataset.removeProduct;


            selectedProducts =
                selectedProducts.filter(
                    product =>
                        product.variantId !== variantId
                );


            /* Regresar botón original */

            const originalButton =
                section.querySelector(
                    `.brms-add[data-variant="${variantId}"]`
                );


            if (originalButton) {

                originalButton.classList.remove("is-added");

                originalButton.textContent = "Agregar";

            }


            renderSelection();

        });


        /* =====================================================
           AGREGAR TODO AL CARRITO
        ===================================================== */

        addAll.addEventListener("click", async () => {

            if (!selectedProducts.length) return;


            const items =
                selectedProducts
                    .map(product => ({
                        id: Number(product.variantId),
                        quantity: 1
                    }))
                    .filter(item => item.id > 0);


            if (!items.length) return;


            addAll.disabled = true;

            addAll.innerHTML = "Agregando...";


            try {

                const response =
                    await fetch("/cart/add.js", {

                        method: "POST",

                        headers: {
                            "Content-Type": "application/json",
                            "Accept": "application/json"
                        },

                        body: JSON.stringify({
                            items: items
                        })

                    });


                if (!response.ok) {

                    throw new Error(
                        "No fue posible agregar los productos."
                    );

                }


                addAll.innerHTML =
                    "¡Agregado! ✓";


                /* Ir al carrito */

                setTimeout(() => {

                    window.location.href = "/cart";

                }, 500);


            } catch (error) {

                console.error(error);

                addAll.disabled = false;

                addAll.innerHTML =
                    `
                    Agregar todo
                    <span class="brms-selection-cart">
                        🛒
                    </span>
                    `;

                alert(
                    "No fue posible agregar los productos al carrito."
                );

            }

        });


        /* Estado inicial */

        renderSelection();

    });

});